import templateUrl from './scannerLoginModal.html';
import './scannerLoginModal.less';

export default angular.module('eventix.common.directives.scannerLoginModal', [])
    /**
     * @ngdoc directive
     * @name eventix.common.directives:scannerLoginModal
     * @description
     * Render the content of the scanner login modal. Should be used inside $uibModal.open()
     */
    .component('scannerLoginModal', {
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: ScannerLoginModal,
        templateUrl: templateUrl
    }).name;

function ScannerLoginModal() {
    const $ctrl = this;

    $ctrl.iOSAppLink = IOS_APP_LINK;
    $ctrl.androidAppLink = ANDROID_APP_LINK;
    $ctrl.isMainBrand = SHOP_BRAND_NAME === 'Eventix';

    $ctrl.scannerType = null;

    $ctrl.$postLink = function() {
        _.assign($ctrl, $ctrl.resolve);

        $ctrl.qrLink = `https://chart.googleapis.com/chart?chs=150x150&cht=qr&chl=${$ctrl.scannerType.QR}&choe=UTF-8&chld=L|1`;
        $ctrl.loginLink = `https://scanapp.eventix.io/login/${$ctrl.scannerType.QR}`;
    };
}
